import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService } from '@app/services/admin/admin.service';

@Component({
  selector: 'app-admin-office-committees-add',
  templateUrl: './admin-office-committees-add.component.html',
  styleUrls: ['./admin-office-committees-add.component.css']
})
export class AdminOfficeCommitteesAddComponent implements OnInit {
  @Input() formdata;
  @Input() offices;
  @Input() committees;
  @Output() doSave = new EventEmitter(); t
  @Output() doCancel = new EventEmitter();
  form;

 
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      officeId: ['', ''],
      committeeId: ['', '']
    });
  }
  
  setOffice(evt) {
    this.form.patchValue({ officeId: evt.value });
  }

  setCommittee(evt) {
    this.form.patchValue({ committeeId: evt.value });
  }

  saveOfficeCommittees() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }
}
